var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropDownSelectInputField',{attrs:{"value":_vm.value,"choices":_vm.choices,"selectFirst":_vm.selectFirst,"defaultValue":_vm.defaultValue},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }